// Community Nearby Shop Management APIs

/**
 * @function ApiClient#GetCommunityShopTypeList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetCommunityShopTypeList(cid, options = {}) {
  return await this._get(`/community/${cid}/shop_types`, options);
}

/**
 * @function ApiClient#GetCommunityShopList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.sortBy
 * @param {any} params.sortDesc
 * @param {any} params.page
 * @param {any} params.itemsPerPage
 * @param {any} params.search
 * @param {any} params.typeId
 * @param {any} options = {}
 */
export async function GetCommunityShopList(cid, { sortBy = "", sortDesc = "", page = "", itemsPerPage = "", search = "", typeId = "" } = {}, options = {}) {
  const url = `/community/${cid}/shops?p=${page}&sb=${sortBy}&sd=${sortDesc}&pp=${itemsPerPage}&name=${search}&typeId=${typeId}`;
  return await this._get(url, options);
}

/**
 * @function ApiClient#GetCommunityShopBlacklist
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.sortBy
 * @param {any} params.sortDesc
 * @param {any} params.page
 * @param {any} params.itemsPerPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function GetCommunityShopBlacklist(cid, { sortBy = "", sortDesc = "", page = "", itemsPerPage = "", search = "" } = {}, options = {}) {
  const url = `/community/${cid}/shop_blacklist?p=${page}&sb=${sortBy}&sd=${sortDesc}&pp=${itemsPerPage}&ss=${search}`;
  return await this._get(url, options);
}

/**
 * @function ApiClient#AddCommunityShopBlacklist
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function AddCommunityShopBlacklist(cid, data, options = {}) {
  return await this._post(`/community/${cid}/shop_blacklist`, data, options);
}

/**
 * @function ApiClient#RemoveCommunityShopBlacklist
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} blacklistId
 * @param {any} options = {}
 */
export async function RemoveCommunityShopBlacklist(cid, blacklistId, options = {}) {
  return await this._delete(`/community/${cid}/shop_blacklist/${blacklistId}`, options);
}

/**
 * @function ApiClient#GetCommunityShopCalls
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.sortBy
 * @param {any} params.sortDesc
 * @param {any} params.page
 * @param {any} params.itemsPerPage
 * @param {any} params.startDate
 * @param {any} params.endDate
 * @param {any} params.shopId
 * @param {any} params.status
 * @param {any} options = {}
 */
export async function GetCommunityShopCalls(
  cid,
  { sortBy = "", sortDesc = "", page = "", itemsPerPage = "", startDate = "", endDate = "", shopId = "", status = "" } = {},
  options = {},
) {
  const url = `/community/${cid}/shop_calls?p=${page}&sb=${sortBy}&sd=${sortDesc}&pp=${itemsPerPage}&st=${startDate}&et=${endDate}&shop=${shopId}&s=${status}`;
  return await this._get(url, options);
}

// ================== 店家管理 API ==================

/**
 * @function ApiClient#GetCommunityManagedShopList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.name
 * @param {any} params.typeId
 * @param {any} params.enabled
 * @param {any} params.page
 * @param {any} params.itemsPerPage
 * @param {any} options = {}
 */
export async function GetCommunityManagedShopList(cid, { name = "", typeId = "", enabled = "", page = 1, itemsPerPage = 10 } = {}, options = {}) {
  let url = `/community/${cid}/managed_shops?name=${name}&typeId=${typeId}&page=${page}&itemsPerPage=${itemsPerPage}`;
  if (enabled !== "") {
    url += `&enabled=${enabled}`;
  }
  return await this._get(url, options);
}

/**
 * @function ApiClient#GetCommunityManagedShop
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} shopId
 * @param {any} options = {}
 */
export async function GetCommunityManagedShop(cid, shopId, options = {}) {
  return await this._get(`/community/${cid}/managed_shops/${shopId}`, options);
}

/**
 * @function ApiClient#CreateCommunityShop
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function CreateCommunityShop(cid, data, options = {}) {
  return await this._post(`/community/${cid}/managed_shops`, data, options);
}

/**
 * @function ApiClient#UpdateCommunityShop
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} shopId
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateCommunityShop(cid, shopId, data, options = {}) {
  return await this._put(`/community/${cid}/managed_shops/${shopId}`, data, options);
}

/**
 * @function ApiClient#UpdateCommunityShopStatus
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} shopId
 * @param {any} enabled
 * @param {any} options = {}
 */
export async function UpdateCommunityShopStatus(cid, shopId, enabled, options = {}) {
  return await this._patch(`/community/${cid}/managed_shops/${shopId}/status`, { Enabled: enabled }, options);
}
